module.exports = __webpack_public_path__ + "img/blog5.59caee61.jpeg";